import { apiClient } from "../ApiClient.ts"

export const fetch_filter_data = async () => {
    return await apiClient.get("/filters-hierarchy")
}